import React, { useState, useEffect } from 'react';
import DetectorController, {
  StoreStatusData,
  StoreStatusModalData,
} from '../../controller/DetectorController';
import OrderController from '../../controller/OrderController';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import 'moment/locale/ko';
import 'moment/locale/ko';
import moment from 'moment-timezone';
import { managers } from '../../controller/ManagerController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  modalData: StoreStatusModalData | null;
  pauseStatus: number | undefined;
  setPauseStatus: any;
};

// {
//   store_name: string;
//   store_id: number;
//   parent_store_sector_name: string;
//   description_business_time: string;
//   description_holiday: string;
// }

const StoreStatusModal = ({
  isVisible,
  setVisible,
  modalData,
  pauseStatus,
  setPauseStatus,
}: Props) => {
  const storeName = modalData && modalData.store_name;
  const storeHoliday = modalData && modalData.description_holiday;
  // const storeSector = modalData && modalData[0].parent_store_sector_name;

  const onCloseModal = () => {
    setVisible(false);
  };

  const setPause = async () => {
    const newPausedState = pauseStatus === 1 ? 0 : 1;

    try {
      const oData = {
        store_id: Number(modalData?.store_id),
        pause: newPausedState,
      };
      const response = await OrderController.setPause(oData);

      if (response && response.data) {
        console.log('response.data', response.data);
        setPauseStatus(newPausedState);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  console.log('pauseStatus====>', pauseStatus);
  useEffect(() => {
    setPauseStatus(pauseStatus);
  }, [pauseStatus]);

  return (
    <Style>
      {isVisible && (
        <div className="modalWrap">
          <div className="modalBackground" onClick={onCloseModal}></div>
          <div className="modal">
            {modalData ? (
              <div className="content">
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                  alt="닫기"
                  width={18}
                  className="modalCloseButton"
                  onClick={onCloseModal}
                />
                <img width={100} className="storeImg" src={`${modalData.logo_url_path}`} />
                <div>
                  <h2>매장명 </h2>
                  <p>{storeName}</p>
                </div>
                <div>
                  <h2>업종 </h2>
                  <p>{modalData.parent_store_sector_name}</p>
                </div>
                <div>
                  <h2>운영시간 </h2>
                  <p>{modalData.description_business_time}</p>
                </div>
                <div>
                  <h2>휴무일 </h2>
                  <p>{storeHoliday ? storeHoliday : '연중무휴'}</p>
                </div>
                <div>
                  <h2>매장주소 </h2>
                  <p>{modalData.address1 + ' ' + modalData.address2}</p>
                </div>
                <div>
                  <h2>매장번호 </h2>
                  <p>{modalData.phone_number}</p>
                </div>
                <div>
                  <h2>사장님번호 </h2>
                  <p>{modalData.ceo_phone_number}</p>
                </div>
                <div>
                  <h2>포스 운영 상태 </h2>
                  <div className="flex">
                    <p> {pauseStatus === 1 ? '일시정지' : '일시정지아님'}</p>
                    <button onClick={() => setPause()} className="pauseButton">
                      {pauseStatus === 0 ? '일시정지하기' : '일시정지풀기'}
                    </button>
                  </div>
                </div>
                <div>
                  <h2>광고중인호텔 </h2>
                  <div>
                    {modalData.hotel_list.map((h) => (
                      <p>
                        {h.store_name} {moment(h.ad_started_at).format('YYYY-MM-DD')}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <h2>정보없음</h2>
            )}
          </div>
        </div>
      )}
    </Style>
  );
};

export default StoreStatusModal;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  .content {
    position: relative;
    width: 35%;
    max-height: 80vh;
    padding: 2%;
    z-index: 9999;
    text-align: left;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow-y: auto;
  }
  .modalCloseButton {
    position: absolute;
    top: 4%;
    right: 3%;
    cursor: pointer;
    width: 26px;
  }
  .storeImg {
    margin-bottom: 10px;
    border-radius: 10px;
  }

  h2 {
    margin-top: 10px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #979797;
  }
  p {
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }
  span {
    color: #ff0000;
  }

  .title {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eee;
  }
  .pauseButton {
    margin-left: 6px;
    padding: 4px 6px;
    font-size: 12px;
    background: #a9a9a9;
    color: #333;
    border: none;
    border-radius: 4px;
  }

  @media (max-width: 800px) {
    h2 {
      font-size: 14px;
    }
    .content {
      width: 80%;
      padding: 5%;
    }
  }
`;
